import styled from 'styled-components';


export const Wrapper = styled.div`
    position: sticky;
    top:0;
    background: linear-gradient(120deg, var(--primaryColor) 30%, var(--secondaryColor) 80%);
    z-index:1;
    max-height: 70px;
    

`;


export const Content = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: ${props => (props.destination ? '1fr 5fr 1fr':'1fr 5fr 1fr')};
    align-items: center;
    color: white;
    justify-content: space-around;
    
    margin:auto;


`;
export const User = styled.div`
background-color:gray;
 border-radius: 10px;
 box-shadow: ${props => (props.switchOn ? '0 5px 9px white inset':'0 5px 9px white inset, 0 5px 9px grey' )};
    display:grid;
    grid-auto-flow:column;
    justify-content: space-between;
    font-size:xx-small;

`;
export const UserText = styled.div`

    padding:10px
 
`;



